/**
 * @module IDEE/ui/position
 */

/**
 * Posición arriba a la izquierda.
 * @public
 * @const
 * @type {string}
 * @api
 */
export const TL = '.m-top.m-left';

/**
 * Posición Arriba a la derecha.
 * @public
 * @const
 * @type {string}
 * @api
 */
export const TR = '.m-top.m-right';

/**
 * Posición abajo a la izquierda.
 * @public
 * @const
 * @type {string}
 * @api
 */
export const BL = '.m-bottom.m-left';

/**
 * Posición abajo a la derecha.
 * @public
 * @const
 * @type {string}
 * @api
 */
export const BR = '.m-bottom.m-right';
